import request from './request';
import deserialize from './deserialize';

export type Employment = {
  id: string;
  role: string;
  company: { id: string };
  user: { id: string };
};

export function get() {
  return request<Employment>({
    url: 'companion/v1/employment',
    method: 'GET',
    transformResponse: deserialize,
  });
}
